export default "__VITE_ASSET__Rytyul7H__"